import axios from "axios";

import { getToken } from "@/utils/tokenStorage";

// Banner que o dono do Núcleo sobe para todas as lojas (null quando não há)
export const lerBanner = async () =>
  (await axios.get("/api/painel/banner", { headers: { Authorization: `Bearer ${getToken()}` }, timeout: 15000 })).data?.banner || null;
